// Zustand-store для отображения модалки "сессия истекла".
// Триггер — 401-интерцептор tRPC client / global fetch wrapper.
// CTA в модалке → редирект на /auth/login (с сохранением returnTo).
//
// `suppress()` — явный выход (performSignOut и т.п.): после revoke сессии
// in-flight запросы получают 401, но это не «истечение», модалку не показываем.
//
// `notifySessionExpiredFrom401()` — единственная точка входа из интерцепторов:
// показывает модалку только если был bearer, затем сразу его чистит. Иначе
// stale-токен после logout / протухшей сессии на каждом reload снова открывал
// попап, а крестик «не работал» (dismiss → следующий 401 → show снова).
import { create } from "zustand";
import { clearAccessToken, getAccessToken } from "./auth-storage";

interface AuthExpiredStore {
	isOpen: boolean;
	/** true — добровольный выход / локально уже разлогинены; show() — no-op. */
	suppressed: boolean;
	show(): void;
	dismiss(): void;
	/** Закрыть модалку и заблокировать повторный показ (явный logout). */
	suppress(): void;
	/** Снять блок после успешного входа. */
	unsuppress(): void;
}

export const useAuthExpiredStore = create<AuthExpiredStore>((set, get) => ({
	isOpen: false,
	suppressed: false,
	show: () => {
		if (get().suppressed) return;
		set({ isOpen: true });
	},
	dismiss: () => {
		// На случай параллельных retry — без токена интерцептор больше не откроет.
		clearAccessToken();
		set({ isOpen: false });
	},
	suppress: () => set({ isOpen: false, suppressed: true }),
	unsuppress: () => set({ suppressed: false }),
}));

/**
 * Реакция на HTTP 401 от защищённого API.
 * @returns true — модалка открыта (или уже была логика suppress).
 */
export function notifySessionExpiredFrom401(): void {
	const store = useAuthExpiredStore.getState();
	if (store.suppressed) return;
	// Нет bearer → это гость (или токен уже сняли). Cookie-only 401 на публичной
	// странице не считаем «истечением сессии».
	if (!getAccessToken()) return;
	clearAccessToken();
	store.show();
}
